import styled from 'styled-components';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';

export default function CloseRequest(props) {
  const { hasCloseRequest } = props;

  return (
    <Container
      title={ReactDOMServer.renderToString(
        <Translator
          file="module-correctiveActions"
          name={
            hasCloseRequest
              ? 'module.ca.close-request'
              : 'module.ca.close-request.no'
          }
        />
      )}
      $hasCloseRequest={hasCloseRequest}
    >
      <AppRemixIcon
        icon="close-circle"
        color={hasCloseRequest ? '#000' : colors.grey300}
      />
    </Container>
  );
}

const Container = styled.div`
  display: ${(props) => (props.$hasCloseRequest ? 'flex' : 'block')};
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.$hasCloseRequest ? colors.bootstrapWarning : '#fff'};
  border-radius: 4px;
`;
